import { render, staticRenderFns } from "./UsarAdicionarProdutoModal.vue?vue&type=template&id=b1ffd09e&scoped=true&"
import script from "./UsarAdicionarProdutoModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UsarAdicionarProdutoModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UsarAdicionarProdutoModal.vue?vue&type=style&index=0&id=b1ffd09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ffd09e",
  null
  
)

export default component.exports